import React, { useEffect, useState } from "react";
import { Table, Input } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { fetchTodayPatients } from "../../Redux/Slice/Doctor/Patients";
import { Tag } from "antd";
import PatientModal from "./PatientModal";

const { Search } = Input;

const statusColors = {
  Booked: "blue",
  BookedByPatient: "green",
  Cancelled: "red",
  Confirmed: "gold",
  Unconfirmed: "orange",
  Rejected: "volcano",
};

const Patient = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user"));
  const doctorId = user?.doctorId;

  const [patients, setPatients] = useState([]);

  const [searchText, setSearchText] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);

  const { data, loading } = useSelector((state) => state.patient.todayPatients);

  useEffect(() => {
    if (data?.status) {
      setPatients(data.data || []);
    }
  }, [data]);

  // console.log(patients, "patients");

  useEffect(() => {
    dispatch(fetchTodayPatients(doctorId));
  }, [dispatch, doctorId]);

  // Filter patients by name
  const filteredPatients = patients.filter((p) =>
    p.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "Sl No",
      key: "slNo",
      render: (_text, _record, index) => index + 1,
    },
    {
      title: "Appointment Date & Time",
      key: "appointmentDateTime",

      render: (record) =>
        `${dayjs(record.appointmentDate).format("YYYY-MM-DD")} ${
          record.appointmentTime
        }`,
    },
    {
      title: "MRD No",
      dataIndex: "mrdNo",
      key: "mrdNo",
    },
    {
      title: "Patient Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Age",
      dataIndex: "age",
      key: "age",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
    },
    {
      title: "Phone",
      dataIndex: "phoneNo",
      key: "phoneNo",
    },
    {
      title: "Appointment Status",
      dataIndex: "appointmentStatus",
      key: "appointmentStatus",
      render: (status) => (
        <Tag color={statusColors[status] || "default"}>{status}</Tag>
      ),
    },
    // {
    //   title: "Confirm Status",
    //   dataIndex: "confirmStatus",
    //   key: "confirmStatus",
    //   // render: (status) => {
    //   //   const colors = {
    //   //     Pending: "orange",
    //   //     Confirmed: "green",
    //   //     Rejected: "red",
    //   //     Cancelled: "volcano",
    //   //   };

    //   //   const displayStatus = status === "Unconfirmed" ? "Pending" : status;

    //   //   return (
    //   //     <Tag color={colors[displayStatus]}>
    //   //       {displayStatus?.toUpperCase()}
    //   //     </Tag>
    //   //   );
    //   // },
    // },
  ];

  return (
    <div>
      {/* Search */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h2 style={{ color: "gray" }}>Today Patients</h2>

        <Search
          placeholder="Search patient by name"
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 300, marginBottom: 16 }}
          allowClear
        />
      </div>
      {/* Table */}
      <Table
        columns={columns}
        dataSource={filteredPatients}
        rowKey="id"
        onRow={(record) => ({
          onClick: () => setSelectedPatient(record), // open modal on row click
        })}
        pagination={{ pageSize: 5 }}
        loading={loading}
      />

      {/* Patient Details Modal */}
      {selectedPatient && (
        <PatientModal
          visible={!!selectedPatient}
          onClose={() => setSelectedPatient(null)}
          patient={selectedPatient}
        />
      )}
    </div>
  );
};

export default Patient;
